import request from '../utils/request'

// 登录到最慧学
export function login (username, password) {
  return request({
    url: 'https://tsdapp.zuihuixue.com/prod-api/zhx/api/login/' + username + '/' + password,
    method: 'get'
  })
}

export function getGradeAndSubjects () {
  return request({
    url: '/zhx/api/user/getGradeAndSubjects',
    method: 'get'
  })
}

export function getUserInfo(){
  return request({
    url: '/zhx/api/user/userInfo',
    method: 'get'
  })
}

export function getTeachClassCourse (year) {
  return request({
    url: `/zhx/teacher/api/jiangping/getTeachClassCourse?year=${year}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/apis/zhxApi.js